export const getDxAiPatientClinicMuiAccordionSummary = (palette: any) => ({
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        backgroundColor: `${palette.surface.main} `,
        // flexDirection: 'row-reverse',
        "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
          transform: "rotate(90deg)",
        },
        "& .MuiAccordionSummary-content": {},
        height: "72px",
      },
      content: {
        alignItems: "center !important",
      },
    },
  },
});
